import { marked } from 'marked';
import sanitize from 'sanitize-html';

type SanitizeCustomOptions = sanitize.IOptions;

export type SanitizeOptions = Pick<SanitizeCustomOptions, 'allowedTags' | 'allowedAttributes' | 'allowedStyles' | 'parseStyleAttributes'>;

const defaultAllowedHtmlTags = [
    ...['h1', 'h2', 'h3', 'h4', 'h5', 'h6'],
    ...['p', 'strong', 'em', 'a', 'b', 'i', 'u', 'sub', 'sup'],
    ...['blockquote', 'q'],
    ...['ul', 'ol', 'li'],
    ...['table', 'thead', 'tbody', 'tr', 'th', 'td'],
    ...['br', 'pre'],
    ...['img'],
];

const defaultAllowedHtmlAttributes = {
    a: ['href', 'rel', 'target'],
    img: ['src', 'alt'],
    p: ['style'],
};

export const transformMarkdownToHtml = (markdown: string): string => marked.parse(markdown) as string;

export const sanitizeHtml = (rawHtml: string, options?: SanitizeOptions): string => {
    const html = transformMarkdownToHtml(rawHtml);

    return sanitize(html, {
        allowedTags: [
            ...defaultAllowedHtmlTags,
            ...(options?.allowedTags || []),
        ],
        allowedAttributes: {
            ...defaultAllowedHtmlAttributes,
            ...(options?.allowedAttributes || {}),
        },
        parseStyleAttributes: false,
    });
};

export const sanitizeAllHtml = (html: string): string => sanitize(html, {
    allowedTags: [],
    allowedAttributes: {},
});
